"use strict";
exports.__esModule = true;
exports.isWWA = function () {
    try {
        if (Windows) {
            return true;
        }
    }
    catch (_a) {
        return false;
    }
    return false;
};
//# sourceMappingURL=Utilities.js.map